const isAnswered = (localAnswer) => !!localAnswer;

export {isAnswered}